import { Button, Divider, Grid } from '@mantine/core';
import { CustomSelect } from '../../styles';
import { isRequestBased, isTransferPricing, staticData } from './constants';
import { moduleRoles } from '../../../../constants';
import { useEffect, useState } from 'react';
import { axios } from '../../../../utils/axios';
import { AppLoader } from '../../../../components/common/loader';

const Form = ({ values, setValues, loading, fetchSpoc }) => {
  const [countries, setCountries] = useState({});
  const { typeOfRequest, bases } = staticData;
  const { type_of_request, base, country, plant, role, costing_request_id } = values;
  const [costingRequests, setCostingRequests] = useState([]);

  useEffect(() => {
    fetchCountries();
    fetchCostingRequest();
  }, []);

  const fetchCountries = async () => {
    try {
      const { data } = await axios.get(`/costing-request/countries_plants`);
      setCountries(data.country_with_plants);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCostingRequest = async () => {
    try {
      const { data } = await axios.get(`/costing-request/get-inprogress-crs`);
      setCostingRequests(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const onChange = (name, value) => {
    setValues((o) => {
      return {
        ...o,
        costing_request_id:
          name === 'base' && !isRequestBased(value) ? undefined : o.costing_request_id,
        [name]: value,
      };
    });
  };

  const isFieldDisabled = () => !type_of_request;

  const isFormValid = () => {
    if (isRequestBased(base)) {
      return costing_request_id && base && role;
    } else {
      if (isTransferPricing(type_of_request)) {
        return base && country && role;
      } else if (type_of_request === 'Costing') {
        return base && country && plant && role;
      }
    }
  };

  return (
    <>
      <Grid fullWidth>
        <Grid.Col md={isRequestBased(base) ? 4 : 6}>
          <CustomSelect
            name='base'
            value={base}
            label='Select bases'
            placeholder='Select Bases'
            data={bases}
            onChange={(value) => onChange('base', value)}
            withAsterisk
          />
        </Grid.Col>
        {!isRequestBased(base) && (
          <Grid.Col md={6}>
            <CustomSelect
              name='type_of_request'
              value={type_of_request}
              label='Select Domain'
              placeholder='Select Domain'
              data={typeOfRequest}
              disabled={!base}
              onChange={(value) => onChange('type_of_request', value)}
              withAsterisk
            />
          </Grid.Col>
        )}

        <Divider />

        {!isRequestBased(base) && (
          <Grid.Col md={isTransferPricing(type_of_request) ? 6 : 3}>
            <CustomSelect
              name='country'
              value={country}
              label='Select Country'
              placeholder='Select Country'
              data={Object.keys(countries)}
              onChange={(value) => {
                onChange('country', value);
                onChange('plant', null);
              }}
              disabled={isFieldDisabled()}
              withAsterisk
            />
          </Grid.Col>
        )}

        {!isTransferPricing(type_of_request) && !isRequestBased(base) && (
          <Grid.Col md={3}>
            <CustomSelect
              name='plant'
              value={plant}
              label='Select Plant'
              placeholder='Select Plant'
              data={countries?.[country] || []}
              onChange={(value) => onChange('plant', value)}
              disabled={isFieldDisabled() || !country}
              withAsterisk
            />
          </Grid.Col>
        )}

        <Divider />

        <Grid.Col md={isRequestBased(base) ? 4 : 6}>
          <CustomSelect
            name='role'
            value={role}
            label='Select Role'
            placeholder='Select Role'
            data={moduleRoles['Costing Request']}
            onChange={(value) => onChange('role', value)}
            disabled={isRequestBased(base) ? !base : isFieldDisabled()}
            withAsterisk
          />
        </Grid.Col>

        {isRequestBased(base) && (
          <Grid.Col md={4}>
            <CustomSelect
              name='costing_request_id'
              value={costing_request_id}
              label='Select Costing Request ID'
              placeholder='Select Costing Request ID'
              data={costingRequests}
              onChange={(value) => onChange('costing_request_id', value)}
              searchable
              withAsterisk
            />
          </Grid.Col>
        )}

        <Divider size={'xl'} />

        <Grid.Col offset={10} md={2}>
          <Button color='dark' fullWidth disabled={!isFormValid()} onClick={fetchSpoc}>
            {loading ? <AppLoader size='sm' variant='dark' /> : 'Search'}
          </Button>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default Form;
